import { render, staticRenderFns } from "./Stacks.vue?vue&type=template&id=19fb5ba3&"
import script from "./Stacks.vue?vue&type=script&lang=js&"
export * from "./Stacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports